/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eisubscaleunderstandingsituationsweak4Inputs */



/**
* | output |
* | --- |
* | "In some situations you may miss the emotional context — deliberately observing your surroundings will improve this skill." |
*
* @param {Eisubscaleunderstandingsituationsweak4Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const eisubscaleunderstandingsituationsweak4 = /** @type {((inputs?: Eisubscaleunderstandingsituationsweak4Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eisubscaleunderstandingsituationsweak4Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("In some situations you may miss the emotional context — deliberately observing your surroundings will improve this skill.")
	if (locale === "es") return /** @type {LocalizedString} */ ("En algunas situaciones puedes pasar por alto el contexto emocional — observar tu entorno de forma consciente mejorará esta capacidad.")
	return /** @type {LocalizedString} */ ("В некоторых ситуациях ты можешь упускать контекст эмоций — осознанное наблюдение за окружением улучшит эту способность.")
});
export { eisubscaleunderstandingsituationsweak4 as "eiSubscaleUnderstandingSituationsWeak" }